import api from './api';

export const categoryService = {
   getAll: async (includeBlogCount = false) => {
      const response = await api.get('/categories', {
         params: { includeBlogCount },
      });
      return response.data;
   },

   getById: async (id) => {
      const response = await api.get(`/categories/${id}`);
      return response.data;
   },

   getBySlug: async (slug) => {
      const response = await api.get(`/categories/slug/${slug}`);
      return response.data;
   },

   create: async (categoryData) => {
      const response = await api.post('/categories', categoryData);
      return response.data;
   },

   update: async (id, categoryData) => {
      const response = await api.put(`/categories/${id}`, categoryData);
      return response.data;
   },

   delete: async (id) => {
      const response = await api.delete(`/categories/${id}`);
      return response.data;
   },

   search: async (query, limit = 20) => {
      const response = await api.get('/categories/search', {
         params: { q: query, limit },
      });
      return response.data;
   },
};
